import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The tour's centered intro; anchored steps are all deck-local — no Carbon0 view describes an
// empty inventory (see decks/materialsCreateDeck.ts).
export const materialsCreateExistingUserSteps: WelcomeStep[] = [
  { key: "materials-create-whats-new", label: "What's new", centered: true },
];
